import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getNormalizedRect} from '~/utils/geometry';
// components
import Gesturable from '~/shared/components/utils/Gesturable';

import './index.scss';

const propTypes = {
  onSelection: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onStart: PropTypes.func,
  onStop: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class SelectionArea extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    isDisabled: false,
    onStart: () => {},
    onStop: () => {}
  };

  state = {
    selectionAreaRect: null
  };

  selectionAreaElement = null;
  selectionStartPoint = null;

  getRelativePosition = (position, element) => {
    const {left, top} = element.getBoundingClientRect();

    return {
      x: position.x - left,
      y: position.y - top
    };
  };

  handleStart = e => {
    if (e.defaultPrevented || this.props.isDisabled) {
      return;
    }

    e.preventDefault();

    this.selectionStartPoint = this.getRelativePosition(
      e.center,
      this.selectionAreaElement
    );

    this.props.onStart(e);
  };

  handleMove = e => {
    if (!this.selectionStartPoint) {
      return false;
    }

    const current = {
      x: this.selectionStartPoint.x + e.deltaX,
      y: this.selectionStartPoint.y + e.deltaY
    };

    const selectionAreaRect = getNormalizedRect(
      this.selectionStartPoint,
      current
    );

    this.setState({selectionAreaRect});
    this.props.onSelection(selectionAreaRect, e);
  };

  handleStop = e => {
    e.preventDefault();

    this.setState({selectionAreaRect: null});
    this.props.onStop(e);
  };

  render() {
    const {selectionAreaRect} = this.state;

    return (
      <Gesturable
        gesture="drag"
        threshold={0}
        onMove={this.handleMove}
        onStart={this.handleStart}
        onStop={this.handleStop}>
        <div
          ref={node => {
            this.selectionAreaElement = node;
          }}
          className="ndx-SelectionArea">
          {selectionAreaRect && (
            <div
              className="ndx-SelectionArea-selection"
              style={selectionAreaRect}
            />
          )}
        </div>
      </Gesturable>
    );
  }
}
